interface EyeOffIconProps {
  stroke?: string;
  width?: number;
  height?: number;
}

export function EyeOffIcon({
  stroke = "#C0C0C0",
  width = 20,
  height = 20,
}: EyeOffIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.585 8.58701C8.20999 8.96215 7.99936 9.47091 7.99945 10.0014C7.99954 10.5318 8.21035 11.0405 8.5855 11.4155C8.96065 11.7905 9.46941 12.0012 9.99986 12.0011C10.5303 12.001 11.039 11.7902 11.414 11.415M14.681 14.673C13.2782 15.5507 11.6547 16.0109 10 16C6.4 16 3.4 14 1 10C2.272 7.88 3.712 6.322 5.32 5.326M8.18 4.18C8.77904 4.05873 9.38881 3.99842 10 4C13.6 4 16.6 6 19 10C18.334 11.11 17.621 12.067 16.862 12.87M1 1L19 19"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
